export default "__VITE_ASSET__l0EVKd$9__"